import { Avatar, CircularProgress, Grid, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import useStyles from '../useStyles'
import { DirRootDetails } from './DirRootDetails'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { createSystemDirectories } from '../../../../redux/actions/Storage'
import { logEvent } from '../../../../utils/LogEvents'
import { useNavigate } from 'react-router-dom'

export const BoxDetails = ({ suborganization, folder }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const createDirectories = async () => {
    const body = {
      suborganizationId: suborganization?.suborganizationId,
      suborganizationName: suborganization?.suborganizationName
    }

    try {
      if (
        body.suborganizationId !== undefined &&
        body.suborganizationName !== undefined
      ) {
        const response = await dispatch(createSystemDirectories(body))
        if (response && response.status === 'success') {
          logEvent('CGI - createSystemDirectories', {
            body: {
              ...body
            },
            response: response
          })
          dispatch(setRequestTextSnackBar())
          dispatch(setSuccessTextSnackBar('Creación de carpeta exitosa'))
          setTimeout(() => {
            navigate(0)
          }, 2000)
        } else {
          dispatch(setRequestTextSnackBar())
          dispatch(
            setErrorTextSnackBar(
              'La organización no tiene un usuario administrador activo'
            )
          )
        }
      }
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error al crear la carpeta'))
    }
  }

  return (
    suborganization && (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Detalles del Estudio
          </Typography>
        </Grid>
        <Grid
          container
          style={{ display: 'flex', alignItems: 'center', padding: 10 }}
        >
          <Grid item>
            <Avatar
              sx={{
                bgcolor: suborganization.suborganizationAvatar.color,
                width: 60,
                height: 60
              }}
            >
              {suborganization.suborganizationAvatar.initials}
            </Avatar>
          </Grid>
          <Grid
            item
            xs={8}
            style={{
              marginLeft: 10,
              display: 'inline-block',
              alignItems: 'center'
            }}
          >
            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              {suborganization.suborganizationName}
            </Typography>

            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              {suborganization.suborganizationCuit}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 17,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Estado de la carpeta del sistema
          </Typography>
        </Grid>
        <div className={classes.buttons}>
          <DirRootDetails folder={folder} />
          {folder?.exist === false && (
            <ButtonConfirm createDirectories={createDirectories} />
          )}
        </div>
      </Grid>
    )
  )
}

function ButtonConfirm ({ showCircularProgress, isError, createDirectories }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)
  const handleButtonClick = async () => {
    try {
      await createDirectories()
    } catch (error) {}
  }
  useEffect(() => {
    if (isError) {
      setProgressComplete(false)
    }
  })
  return (
    <div>
      <button
        className={classes.confirmButton}
        disabled={isProgressComplete && showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Crear Carpeta
          </Typography>
            )}
      </button>
    </div>
  )
}
